export default {"src":"/_next/static/media/settings.9c8c8f7e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};